/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicProgram,
    AcademicProgramFromJSON,
    AcademicProgramFromJSONTyped,
    AcademicProgramToJSON,
    State,
    StateFromJSON,
    StateFromJSONTyped,
    StateToJSON,
} from './';

/**
 * Item que muestra los filtros a mostrar
 * @export
 * @interface CompanyApplicationFilers
 */
export interface CompanyApplicationFilers {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyApplicationFilers
     */
    showGeneral?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyApplicationFilers
     */
    showAcademicProgramScopes?: boolean;
    /**
     * 
     * @type {Array<AcademicProgram>}
     * @memberof CompanyApplicationFilers
     */
    academicProgramScopeList?: Array<AcademicProgram>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyApplicationFilers
     */
    showFinishedPercent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyApplicationFilers
     */
    showKillerGrade?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyApplicationFilers
     */
    showStates?: boolean;
    /**
     * 
     * @type {Array<State>}
     * @memberof CompanyApplicationFilers
     */
    stateList?: Array<State>;
}

export function CompanyApplicationFilersFromJSON(json: any): CompanyApplicationFilers {
    return CompanyApplicationFilersFromJSONTyped(json, false);
}

export function CompanyApplicationFilersFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyApplicationFilers {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showGeneral': !exists(json, 'show_general') ? undefined : json['show_general'],
        'showAcademicProgramScopes': !exists(json, 'show_academic_program_scopes') ? undefined : json['show_academic_program_scopes'],
        'academicProgramScopeList': !exists(json, 'academic_program_scope_list') ? undefined : ((json['academic_program_scope_list'] as Array<any>).map(AcademicProgramFromJSON)),
        'showFinishedPercent': !exists(json, 'show_finished_percent') ? undefined : json['show_finished_percent'],
        'showKillerGrade': !exists(json, 'show_killer_grade') ? undefined : json['show_killer_grade'],
        'showStates': !exists(json, 'show_states') ? undefined : json['show_states'],
        'stateList': !exists(json, 'state_list') ? undefined : ((json['state_list'] as Array<any>).map(StateFromJSON)),
    };
}

export function CompanyApplicationFilersToJSON(value?: CompanyApplicationFilers | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'show_general': value.showGeneral,
        'show_academic_program_scopes': value.showAcademicProgramScopes,
        'academic_program_scope_list': value.academicProgramScopeList === undefined ? undefined : ((value.academicProgramScopeList as Array<any>).map(AcademicProgramToJSON)),
        'show_finished_percent': value.showFinishedPercent,
        'show_killer_grade': value.showKillerGrade,
        'show_states': value.showStates,
        'state_list': value.stateList === undefined ? undefined : ((value.stateList as Array<any>).map(StateToJSON)),
    };
}


